import { TextInput, TextInputProps } from '@mantine/core';
import { memo } from 'react';
import { RegisterOptions, useController } from 'react-hook-form';

interface Props extends TextInputProps {
	rhfOptions?: RegisterOptions;
	name: string;
}

const MantineTextInput = ({ name, rhfOptions, className, placeholder, ...props }: Props) => {
	const {
		field,
		fieldState: { error },
	} = useController({ name, rules: rhfOptions });

	return (
		<TextInput
			className={className}
			error={error?.message}
			placeholder={placeholder ?? props.label?.toString() ?? 'Type in'}
			{...field}
			{...props}
		/>
	);
};
const _MantineTextInputExport = memo(MantineTextInput);

export { _MantineTextInputExport as MantineTextInput };
